export default "__VITE_ASSET__CXPMcbGe__"